export default "__VITE_ASSET__8703399f__"